import Accordion from './js/components/accordion'
import initBlogFilter from './js/components/blog-filter'
import initPillarPageGuide from './js/components/pillar-guide'
import initDomainLookup from './js/components/domain-lookup'
import LazyLoad from 'vanilla-lazyload'
import LinkTile from './js/behaviours/link-tile'
import MobileMenu from './js/components/mobile-menu'
import PageReady from './js/behaviours/page-ready'
import React from 'react'
import ReactDOM from 'react-dom'
import RegisterDomain from '../../inz/src/js/components/RegisterDomain'
import SkipToContent from './js/behaviours/skip-to-content'

/**
 * Initialise site components and behaviours.
 */
PageReady.ready(() => {
  Accordion.init()
  LinkTile.init()
  MobileMenu.init()
  SkipToContent.init()

  initBlogFilter()
  initPillarPageGuide()
  initDomainLookup()

  // Add the register domain component
  const registerDomain = document.getElementById('register-domain')
  if (registerDomain) {
    ReactDOM.render(
      <RegisterDomain
        stepOneContent={registerDomain.dataset.content}
        helperStepOne={registerDomain.dataset.helperStepOne}
        helperUnsupportedCharacters={registerDomain.dataset.helperUnsupportedCharacters}
        helperStepTwo={registerDomain.dataset.helperStepTwo}
        helperStepThree={registerDomain.dataset.helperStepThree}
        registrarFilters={registerDomain.dataset.registrarFilters}
        isNewRegistry={registerDomain.dataset.isNewRegistry === '1'}
        contactLink={registerDomain.dataset.contactLink}
        tlds={registerDomain.dataset.tlds}
        isJumpstarter={true}
      />,
      registerDomain,
    )
  }

  // Lazy load images
  const lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
  })
  lazyLoadInstance.update()
})
